module.exports = __webpack_public_path__ + "static/img/Ícono_Eureka copia@4x.f670d7f6.png";